import axios, { AxiosHeaders } from 'axios';
import type { InternalAxiosRequestConfig } from 'axios';

import i18n from '@app/i18n';

const HEADER = 'Accept-Language';

/**
 * Injects an Accept-Language header (from i18next) onto an axios request
 * config, only when the request does not already define one.
 */
export const applyAcceptLanguage = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const lang = i18n.language || 'en';
  const headers = AxiosHeaders.from(config.headers);

  if (!headers.has(HEADER)) {
    headers.set(HEADER, lang);
  }

  config.headers = headers;
  return config;
};

let registered = false;

/** Registers the interceptor once on the global axios singleton. */
export const registerAcceptLanguageInterceptor = (): void => {
  if (registered) return;
  registered = true;
  axios.interceptors.request.use(applyAcceptLanguage);
};
